export const environment = {
  production: true,
  nau_url: 'https://app.naumatch.com.br/',
  mobile_url_nau: 'https://match.naumatch.com.br/mobile/',
  web_url_nau: 'https://match.naumatch.com.br/',
  url_api: 'https://new-match-api.naumatch.com.br/',
  auth_url_api: 'https://new-match-api.naumatch.com.br/auth/',
  googleUrl: `https://new-match-api.tamboro.com.br/google/login`,
  vapid_key:
    'BHbsUKdytXK6gapQq90GbWC2LbM_YWyTgwc-2IIzd7bEOSiWmDWFbiA63Shb_laJ7nmKD-McCn5tkRIEQWKn-0Q',
};
